import React from 'react'

function Error404() {
  return (
    <div className='container'>
      <h1 className="title">404. PAGE NOT FOUND!</h1>

    </div>
  )
}

export default Error404
